module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_layer_on-aaa35982dcf88e42e395404f2aaf7bf9.png";